<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
      </b-alert>
      <b-alert v-if="!response.errors" :show="dismissCountDown"
                dismissible
                :variant="response.success== true ? 'success':'danger'"
                @dismissed="dismissCountdown=0"
                @dismiss-count-down="countDownChanged">
          <strong v-if="!response.errors">{{response.message}}</strong>
      </b-alert>
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <form action="#" @submit.prevent="checkSecretCode">
                  <h1>Code d'accès</h1>
                  <p class="text-muted">Un code d'accès vous a été envoyé par email, saisissez le et accédez à votre espace de travail.</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-credit-card"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Votre code d'accès ici" autocomplete="code" v-model="code" />
                  </b-input-group>
                  <b-row >
                    <b-col cols="6">
                      <b-button type="submit" variant="primary" class="px-4">Valider</b-button>
                    </b-col>
                    <b-col cols="6" class="text-left">
                      <b-button variant="link" @click="logout" class="px-0">Annuler connexion</b-button>
                    </b-col>
                  </b-row>
                </form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="background-color: #215aa9 !important;width:44%">
              <b-card-body class="text-center no-padding">
                <div>
                  <p class="time-title">Temps restant</p>
                  <span class="time-left">{{remaingTime}}</span>
                  <p class="time-title">secondes</p>
                  <!--<b-button variant="primary" class="active mt-3">Register Now!</b-button>-->
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SecretCode',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      code:'',
      remaingTime: 181,
      timeout:null
    }
  },
  mounted(){
    //console.log('je monte le store',this.$store.getters['auth/userPermissions'])
  },
  methods:{
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    checkSecretCode(){
      if(this.code.trim('').length == 0)
        return
        
      console.log('We are in the secret code here')
      
      this.$store.dispatch('auth/login_step_two',{
        code: this.code
      })
      .then(response =>{
        console.log('redirection vers le dashboard')
        //this.$router.push({ name : 'Dashboard'})
        this.$router.push({
            name: 'Dashboard', 
            params: { reload_option: true }
        });
        //this.$router.push('/dashboard')
        
      })
      .catch(error=>{
        //console.log("ssssss")
        this.response.message = error.response.data.message
        //this.response.message = "dd"
        this.showAlert()
        return
      })
    },
    logout_timer(){
      this.remaingTime--
      if(this.remaingTime > 0){        
      //this.remaningTime < 30 && 
        this.timeout = setTimeout(this.logout_timer, 1000)
      }else {
        //On se déconnecte
          this.$router.push({name:'Logout'})
        console.log('About to be disconnected')
      }
    },    
    logout(){
      this.$router.push({name:'Logout'})
    }
  },
  computed:{
    // get_user(){
    //   return this.$store.getters['auth/get_user'].username
    // }
  },

  created(){
    this.logout_timer()
  }, 

  beforeDestroy(){
    clearTimeout(this.timeout)
  }
}
</script>

<style>
  .time-left {
    font-size: 96px;
  }

  .time-title {
    margin: 0;
  }

  .no-padding {
    padding: 0;
  }
</style>

